import {biErrorLogger} from '../biErrorLogger';
import {BiError} from '../biErrorLogger/biErrorLoggerFactory';
import {BI_ERRORS} from '../biErrorLogger/biErrors';
import {logException} from './logException';

interface Opts {
  reason?: Error | string;

  [key: string]: any;
}

const safe =
  (cb, fallback = undefined) =>
  (v) =>
    typeof v === 'object' && v !== undefined ? cb(v) : false;
const seenReasons = new WeakSet();

const seeReason = safe((value) => seenReasons.add(value));
const isSeen = safe((value) => seenReasons.has(value));

export const errorLogger = {
  logError(
    {bi, biParams = []}: {bi: BiError; biParams?: (undefined | string | number | boolean)[]},
    {reason, ...extra}: Opts = {},
  ) {
    if (!bi || !bi.id) {
      console.error('Bi Param is empty');
    }
    if (reason) {
      seeReason(reason);
      logException(reason, extra, bi);
    }

    return biErrorLogger.logError(bi, ...biParams);
  },
  logIfNotSeen(
    {bi, biParams = []}: {bi: BiError; biParams?: (undefined | string | number | boolean)[]},
    {reason, ...extra}: Opts = {},
  ) {
    if (!reason || isSeen(reason)) {
      return;
    }
    errorLogger.logError({bi, biParams}, {reason, ...extra});
  },
  createLoggingCatcher({bi}: {bi: BiError}) {
    return (reason) => {
      errorLogger.logError({bi}, {reason});
      return Promise.reject(reason);
    };
  },
};

export const installUnhandled = () => {
  const original = window.onunhandledrejection && window.onunhandledrejection.bind(window);
  window.onunhandledrejection = (...args) => {
    if (original) {
      try {
        original(...args);
      } catch (ex) {
        console.error(ex);
      }
    }
    const [event] = args;
    errorLogger
      .logError(
        {bi: BI_ERRORS.getWindow.unhandled.rejection},
        {reason: event && event.reason ? event.reason : 'reason unknown'},
      )
      .catch((reason) => {
        console.error('Unable to send unhandled.rejection error', reason);
      });
  };
  return () => {
    window.onunhandledrejection = original;
  };
};
